import React, { useState, useEffect } from "react";
import styled from "styled-components";
import WynikiForm from "./resultsManager";
import MiejscaGier from "./gamesManager";
import MatchManager from "./matchesManager";

// --- Styled Components ---
const Container = styled.div`
  max-width: 800px;
  margin: 40px auto;
  padding: 20px;
  background: #f9f9f9;
  border-radius: 15px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.1);
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 30px;
`;

const Input = styled.input`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
`;

const Select = styled.select`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  font-size: 16px;
`;

const Button = styled.button`
  padding: 10px 16px;
  border-radius: 8px;
  border: none;
  background: ${(props) => props.color || "#234ffc"};
  color: white;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s ease;

  &:hover {
    background: ${(props) => props.hover || "#123eeb"};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

const RocznikItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: white;
  padding: 12px;
  border-radius: 12px;
  margin-bottom: 10px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
`;
// --- Styled Components dla multi-select ---
const MultiSelectWrapper = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
`;

const MultiSelectButton = styled.div`
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #ccc;
  cursor: pointer;
  background: white;
  font-size: 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const OptionsDropdown = styled.div`
  position: absolute;
  top: 110%;
  left: 0;
  right: 0;
  background: white;
  border: 1px solid #ccc;
  border-radius: 8px;
  max-height: 150px;
  overflow-y: auto;
  z-index: 10;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
`;

const OptionItem = styled.label`
  display: flex;
  align-items: center;
  padding: 6px 10px;
  cursor: pointer;
  &:hover {
    background: #f0f0f0;
  }
  input {
    margin-right: 8px;
  }
`;

// --- Komponent MultiSelect dla dni treningów ---
const MultiSelectDays = ({ value, onChange, options }) => {
    const [open, setOpen] = useState(false);

    const toggleOption = (val) => {
        if (value.includes(val)) {
            onChange(value.filter(v => v !== val));
        } else {
            onChange([...value, val]);
        }
    };

    return (
        <MultiSelectWrapper>
            <MultiSelectButton onClick={() => setOpen(!open)}>
                {value.length === 0 ? "Wybierz dni" : value.map(v => options.find(o => o.value === v)?.label).join(", ")}
                <span style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}>▼</span>
            </MultiSelectButton>
            {open && (
                <OptionsDropdown>
                    {options.map(opt => (
                        <OptionItem key={opt.value}>
                            <input
                                type="checkbox"
                                checked={value.includes(opt.value)}
                                onChange={() => toggleOption(opt.value)}
                            />
                            {opt.label}
                        </OptionItem>
                    ))}
                </OptionsDropdown>
            )}
        </MultiSelectWrapper>
    );
};


const weekdayOptions = [
    { value: 0, label: "Niedziela" },
    { value: 1, label: "Poniedziałek" },
    { value: 2, label: "Wtorek" },
    { value: 3, label: "Środa" },
    { value: 4, label: "Czwartek" },
    { value: 5, label: "Piątek" },
    { value: 6, label: "Sobota" },
];

// --- Komponent ---
export default function RocznikManager() {
    const [roczniki, setRoczniki] = useState([]);
    const [formData, setFormData] = useState({
        rocznik: "",
        trener: "",
        liczbaZawodników: "",
        miejsceTreningów: "",
        dniTreningow: [], // nowa właściwość jako tablica numerów dni tygodnia
        kolor1: "",
        kolor2: "",
    });
    const [editingId, setEditingId] = useState(null);
    const [loading, setLoading] = useState(false);

    // --- Fetch roczniki ---
    const fetchRoczniki = async () => {
        try {
            const res = await fetch("https://api.pth-hokej.pl/api/roczniki");
            const data = await res.json();
            setRoczniki(data);
        } catch (err) {
            console.error(err);
        }
    };

    useEffect(() => {
        fetchRoczniki();
    }, []);

    // --- Handle input change ---
    const handleChange = (e) => {
        const { name, value, selectedOptions } = e.target;
        if (name === "dniTreningow") {
            // Konwertujemy wybrane opcje na tablicę numerów
            const values = Array.from(selectedOptions).map(opt => parseInt(opt.value));
            setFormData({ ...formData, [name]: values });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    // --- Add or Update rocznik ---
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        console.log("TEST4", formData)
        try {
            if (editingId) {
                const res = await fetch(`https://api.pth-hokej.pl/api/roczniki/${editingId}`, {
                    method: "PUT",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formData),
                });
                await res.json();
                setEditingId(null);
            } else {
                const res = await fetch("https://api.pth-hokej.pl/api/roczniki", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify(formData),
                });
                await res.json();
            }

            setFormData({
                rocznik: "",
                trener: "",
                liczbaZawodników: "",
                miejsceTreningów: "",
                dniTreningow: [],
                kolor1: "",
                kolor2: "",
            });
            fetchRoczniki();
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    // --- Edit ---
    const handleEdit = (rocznik) => {
        setEditingId(rocznik._id);
        setFormData({
            rocznik: rocznik.rocznik || "",
            trener: rocznik.trener || "",
            liczbaZawodników: rocznik.liczbaZawodników || "",
            miejsceTreningów: rocznik.miejsceTreningów || "",
            dniTreningow: rocznik.dniTreningow || [],
            kolor1: rocznik.kolor1 || "",
            kolor2: rocznik.kolor2 || "",
        });
        window.scrollTo({ top: 0, behavior: "smooth" });
    };

    // --- Delete ---
    const handleDelete = async (id) => {
        if (!window.confirm("Na pewno chcesz usunąć ten rocznik?")) return;
        try {
            await fetch(`https://api.pth-hokej.pl/api/roczniki/${id}`, { method: "DELETE" });
            fetchRoczniki();
        } catch (err) {
            console.error(err);
        }
    };

    return (
        <>
            <Container>
                <h2>{editingId ? "Edytuj rocznik" : "Dodaj nowy rocznik"}</h2>

                <Form onSubmit={handleSubmit}>
                    <Input
                        name="rocznik"
                        placeholder="Rocznik"
                        value={formData.rocznik}
                        onChange={handleChange}
                    />
                    <Input
                        name="trener"
                        placeholder="Trener"
                        value={formData.trener}
                        onChange={handleChange}
                    />
                    <Input
                        name="liczbaZawodników"
                        placeholder="Liczba zawodników"
                        type="number"
                        value={formData.liczbaZawodników}
                        onChange={handleChange}
                    />
                    <Input
                        name="miejsceTreningów"
                        placeholder="Miejsce treningów"
                        value={formData.miejsceTreningów}
                        onChange={handleChange}
                    />

                    {/* Wybór dni treningów */}
                    <label>Dni treningów:</label>
                    <MultiSelectDays
                        value={formData.dniTreningow}
                        onChange={(vals) => setFormData({ ...formData, dniTreningow: vals })}
                        options={weekdayOptions}
                    />


                    {/* Wybór kolorów */}
                    <label>
                        Kolor 1:
                        <Input
                            type="color"
                            name="kolor1"
                            value={formData.kolor1 || "#234ffc"}
                            onChange={handleChange}
                        />
                    </label>

                    <label>
                        Kolor 2:
                        <Input
                            type="color"
                            name="kolor2"
                            value={formData.kolor2 || "#123eeb"}
                            onChange={handleChange}
                        />
                    </label>

                    <Button type="submit" disabled={loading}>
                        {editingId ? "Zaktualizuj" : "Dodaj"}
                    </Button>

                    {editingId && (
                        <Button
                            type="button"
                            disabled={loading}
                            onClick={() => {
                                setEditingId(null);
                                setFormData({
                                    rocznik: "",
                                    trener: "",
                                    liczbaZawodników: "",
                                    miejsceTreningów: "",
                                    dniTreningow: [],
                                    kolor1: "",
                                    kolor2: "",
                                });
                            }}
                            style={{ marginTop: "8px", background: "#5bc0de", hover: "#31b0d5" }}
                        >
                            Dodaj nowy
                        </Button>
                    )}
                </Form>

                {editingId && <MiejscaGier rocznikId={editingId} />}
                {editingId && <MatchManager rocznikId={editingId}/>}
                {editingId && <WynikiForm rocznikId={editingId} />}

                <h3>Lista roczników</h3>
                {roczniki.map((r) => (
                    <RocznikItem key={r._id}>
                        <div>
                            <strong>{r.rocznik}</strong> – {r.trener} ({r.liczbaZawodników} zawodników)
                        </div>
                        <div>
                            <Button onClick={() => handleEdit(r)} style={{ marginRight: "8px" }} color="#f0ad4e" hover="#ec971f">
                                Edycja
                            </Button>
                            <Button onClick={() => handleDelete(r._id)} color="#d9534f" hover="#c9302c">
                                Usuń
                            </Button>
                        </div>
                    </RocznikItem>
                ))}
            </Container>
        </>
    );
}
